import script from "./FooterMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterMobile.vue?vue&type=script&setup=true&lang=js"

import "./FooterMobile.vue?vue&type=style&index=0&id=20ce7540&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ce7540"]])

export default __exports__